
    import Component from "vue-class-component";
    import Vue from "vue";
    import { DefaultCatch } from "catch-decorator-ts";
    import { defaultErrorHandler } from "@/common/utils/defaultErrorHandler";
    import type {
        Pagination,
        IdPagedQueryData,
        CutieFilterState,
        PetFilter,
        PetFilterOptions,
    } from "@/app/cuties/list/CutieListApiService";
    import CutieListApiService from "@/app/cuties/list/CutieListApiService";
    import CutieListFiltersCriteria from "@/app/components/cutie/list/CutieListFiltersCriteria.vue";
    import qs from "qs";
    import { removeEmptyValues } from "@/app/cuties/utils/utils";
    import CutieListAllPaginatedContent from "@/app/views/cutie-lists/CutieListPaginatedContents.vue";

    /** the new age _Marketplace -> All_ page */
    @Component({
        components: { CutieListFiltersCriteria, CutieListAllPaginatedContent },
    })
    export default class CutieListAll extends Vue {
        private initialPagination: Pagination = {
            direction: "DESC",
            maxId: null,
        };
        private showFilters = true;
        private filterOptions: PetFilterOptions | null = null;
        private filterState: CutieFilterState<string | number> = {};
        private showStats = false;
        private totalCutiesInTheGame: number | null = null;

        created() {
            const queryStr = this.$route.fullPath.split("?")[1] ?? "";
            if (queryStr) {
                const queryData: IdPagedQueryData = qs.parse(queryStr) as any;
                const { direction, minId, maxId, ...filterState } = queryData;
                this.filterState = filterState;
                this.initialPagination = direction === "ASC"
                    ? { direction: "ASC", minId: +minId! }
                    : { direction: "DESC", maxId: maxId ? +maxId : null };
            }
        }

        @DefaultCatch(defaultErrorHandler)
        async mounted() {
            CutieListApiService.listAllCount().then(rs => {
                this.totalCutiesInTheGame = rs.count;
            });
        }

        @DefaultCatch(defaultErrorHandler)
        async clearFilters() {
            this.filterState = {};
        }

        get hasEnteredFilters() {
            const cleanData = removeEmptyValues(this.filterState);
            return Object.keys(cleanData).length > 0;
        }

        @DefaultCatch(defaultErrorHandler)
        async updateFiltersState(newState: PetFilter) {
            this.filterState = newState;
        }

        async loadingPageOnAction(pagination: Pagination) {
            const queryData: IdPagedQueryData = removeEmptyValues({
                ...this.filterState, ...pagination,
            });
            await this.$router.push({
                path: "/" + this.$i18n.locale + "/cutie-list-all?" + qs.stringify(queryData),
            }).catch(() => {});
        }
    }
